<div class="flex flex-col h-full max-w-2xl">
<div class="flex flex-row justify-between items-center pb-2">
    <span class="text-lg">Filtrar Usuários</span>

    <button mat-icon-button mat-dialog-close>
        <mat-icon svgIcon="heroicons_outline:x-circle"></mat-icon>
    </button>
</div>

<div class="flex-auto flex max-w-[90%] p-3">
    <mat-form-field class="fuse-mat-dense fuse-mat-rounded mat-form-field-bg-light w-full justify-center" subscriptSizing="dynamic">
      <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_outline:magnifying-glass"></mat-icon>

      <input matInput [formControl]="myControl" [autocomplete]="'off'" placeholder="Pesquisar aplicação"/>

    </mat-form-field>
  </div>

<div class="flex flex-col space-y-4 p-1 overflow-y-auto">

    @if (dataCa$ | async; as dataCa)
    {
        <!-- Client Application selection filter -->
        <div class="flex flex-col space-y-1">
            <label>Usuários com acesso em:</label>

            <mat-chip-listbox class="mat-mdc-chip-set-stacked w-min" multiple="true" [(ngModel)]="filters.clientApplicationIds">
                @for (ca of filteredChips(); track ca.id)
                {
                    <mat-chip-option [value]="ca.id">
                        {{ ca.client.name}} - {{ ca.application.name}}
                    </mat-chip-option>
                }
            </mat-chip-listbox>
        </div>

        <!-- User status -->
        <div class="flex flex-col space-y-1">
            <label>Status:</label>
            
            <mat-chip-listbox class="mat-mdc-chip-set-stacked min-w-22 w-min" [(ngModel)]="filters.isActive">
                <mat-chip-option value="true">Ativo</mat-chip-option>
                <mat-chip-option value="false">Inativo</mat-chip-option>
            </mat-chip-listbox>
        </div>

        <!-- Filter button -->
        <div class="w-full">
            <button mat-flat-button color="primary" class="w-full" (click)="onFilterClick()">
                Filtrar
            </button>
        </div>
    } @else {
        <div class="flex flex-row items-center justify-center space-x-2 p-8">
            <span class="text-lg">Carregando dados...</span>

            <mat-spinner diameter="35"></mat-spinner>
        </div>
    }
</div>
</div>

